import React, { Component } from "react";
import NodataFound from "../assets/nodatafound.png";
class NoDataFound extends Component {
  render() {
    const { pendingTask, pragatipage, pendingComments } = this.props;
    const NoPendingTaskIcon =
      "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_pending_task.png";
    const NoDataFoundIcon =
      "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png";
    return (
      <div className="no-data-wrapper">
        <img
          src={
            pendingTask || pendingComments
              ? NoPendingTaskIcon
              : pragatipage
              ? NodataFound
              : NoDataFoundIcon
          }
          alt="No Data"
        />
        <h3
          className={`no-data-found`}
          style={{ lineHeight: pragatipage ? 2 : 0.5 }}
        >
          {pendingTask
            ? "No Pending Tasks"
            : pendingComments
            ? "No Pending Comments"
            : "No Data Found"}
        </h3>
      </div>
    );
  }
}

export default NoDataFound;
